import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { post } from "@/libs/http";
import { BlackCheckReq, BlackCheckRes } from '@/types/api/user-auth/black-check.d';

export enum BlackStatus {
  BLACK_STATUS_YES = 1,
  BLACK_STATUS_NO = 2,
}

export enum IsPassword {
  IS_PASSWORD_YES = 1,
  IS_PASSWORD_NO = 2,
}

export const blackCheck = ({ params }: { params: BlackCheckReq; }) => post<BlackCheckRes>('/user/auth/v1/blackCheck', params);

export const useBlackCheck = createApiMutationHook(blackCheck);